import { FormControl, FormLabel } from '@chakra-ui/react';
import { TransactionPropertyType } from '@client/graphql/__generated__/types';
import { Select } from '@document/common/Select';
import { FC } from 'react';
import { useOrganizationCompliancePage } from '../../pages/Organizations/Compliance/OrganizationCompliancePageContext';

interface PropertyTypeOption {
  label: string;
  value: TransactionPropertyType;
}

// Convert enum value to display label (capitalize first letter, lowercase rest)
const getPropertyTypeLabel = (
  propertyType: TransactionPropertyType
): string => {
  return (
    propertyType.charAt(0).toUpperCase() + propertyType.slice(1).toLowerCase()
  );
};

// Generate options from all enum values
const propertyTypeOptions: PropertyTypeOption[] = Object.values(
  TransactionPropertyType
).map((propertyType) => ({
  label: getPropertyTypeLabel(propertyType),
  value: propertyType,
}));

export const PropertyTypeFilter: FC = () => {
  const { propertyTypeFilter, setPropertyTypeFilter } =
    useOrganizationCompliancePage();

  const handleChange = (option: PropertyTypeOption | null) => {
    setPropertyTypeFilter(option?.value || null);
  };

  const selectedOption =
    propertyTypeOptions.find((option) => option.value === propertyTypeFilter) ||
    null;

  return (
    <FormControl minWidth="150px">
      <FormLabel>Property Type</FormLabel>
      <Select
        isClearable
        options={propertyTypeOptions}
        placeholder="All types"
        size="sm"
        styles={{
          container: (provided) => ({
            ...provided,
            minWidth: 150,
          }),
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
          }),
        }}
        value={selectedOption}
        onChange={handleChange}
      />
    </FormControl>
  );
};
